module.exports = __webpack_public_path__ + "img/IMG_0689.1fe08f0e.jpg";